import { useEffect, useState } from "react";

// Modules
import { useSelector } from "react-redux";

// App
import { getOnlineNode } from "../../core//getNode";
import { patchNode } from "../../core/postNode";
import CompanyappLoader from "../../partials/companyappLoader";
import PageHeader from "../../partials/pageHeader";

// UI
import {
  Alert,
  Snackbar,
  IconButton,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import { Row, Col } from "react-bootstrap";

import { FileDownloadOutlined, Close } from "@mui/icons-material";
import Creator from "../../partials/creator";
import caLogoMin from "../../assets/ca-logo.png";

const winLogo =
    '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.32 87.6"> <path fill="#00adef" d="M0,12.4,35.69,7.54V42L0,42.17ZM35.67,45.93l0,34.45L0,75.48V45.7ZM40,6.91,87.31,0V41.53L40,41.9ZM87.32,46.25V87.6L40,80.92l-.07-34.74Z" /> </svg>';
  const macLogo =
    '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080.16 1079.98"><defs><style>.cls-1{fill:#010101;}.cls-2{fill:#060606;}</style></defs><title>mac-logo</title><path class="cls-1" d="M419.93,539.56C420.07,238.07,659.32-.16,961.79,0,1261.76.2,1500.46,240.07,1500.1,541s-239.63,539.28-541.33,539C658.48,1079.76,419.8,840.36,419.93,539.56ZM967.46,653c-.5-9.94-.43-20-1.65-29.8a240.44,240.44,0,0,0-6-32.43c-12.84-48.22-39.69-85.24-86.73-105.26-26.71-11.38-54.86-14.24-83.58-11.83-61.81,5.18-106.89,35.18-130,93.12C637,623,637.45,680.69,659,737.39c15.42,40.56,43.94,69.18,85,84.3,27.83,10.25,56.64,12.69,86.07,8.86,53.2-6.9,92.85-33.24,117-81.54C962.11,718.84,967.31,686.42,967.46,653Zm168.78-180.75c-11.64,1.32-23.45,1.79-34.88,4.12-29.75,6.07-55.61,19.06-73.84,44.52-23.46,32.75-27.67,96.88,28.46,126.54,9,4.78,18.48,9.25,28.24,12.16,21.06,6.27,42.45,11.41,63.69,17.07,16.48,4.39,32.9,9,47,19.07,23.35,16.67,27.15,48,7.38,68.78a75.84,75.84,0,0,1-24.27,16.68c-24.74,10.75-50.48,10.68-76.07,2.94-25.43-7.7-44-22.7-49.86-50-.65-3.09-1.72-4.13-4.72-4.11-13.51.09-27,.15-40.54,0-4.08,0-4.77,1.81-4.26,5.19.37,2.46.34,5,.8,7.42,6.65,35,26.38,60.45,58.66,74.76,47.18,20.9,95.53,20.49,142.9,1.1,43.84-17.94,65.43-57.14,60-104.43-2.26-19.81-10.6-36.63-25.88-49.82a107.45,107.45,0,0,0-37.68-21.5c-22.63-7.16-45.64-13.09-68.52-19.43-17.43-4.83-35.14-8.92-50.55-19-20.17-13.2-25.65-35.52-14.09-56.76,6.42-11.78,16.49-19.3,28.55-24.49,16.47-7.08,33.76-8,51.28-6.46,32.16,2.8,58.18,21.85,62.43,51.24.59,4.14,2.46,6,7,5.86,12.08-.32,24.19-.28,36.27,0,5.06.11,6.8-1.12,6.19-6.67-3.07-28-15.4-50.7-37.73-67.8C1197,479.67,1167.59,473.05,1136.24,472.21ZM756.43,344.7c0,16.7.19,33.41-.11,50.11C756.23,400,758,402,763,401.23a31.84,31.84,0,0,1,4.26,0c12.19-.09,10.68,1.13,10.72-10.88.07-18.83-.1-37.67.07-56.5.1-10.12,3.78-18.77,12.44-24.56,12-8,34.42-4.14,34.6,18.93.15,19.54,0,39.09,0,58.64,0,14.69,0,14.38,14.54,14.52,6,.06,7.72-1.77,7.62-7.71-.35-19.19-.23-38.38-.06-57.57a53.84,53.84,0,0,1,1.57-13.66c3.32-12.12,14.92-19,27.17-16.59,11.17,2.18,17.16,9.7,17.41,23.32.34,18.83.11,37.67.11,56.51,0,17.27,0,17.13,17.63,15.66,3.76-.31,4.85-1.63,4.83-5.1-.19-25.93.32-51.9-.62-77.81-.68-18.66-14.56-31.33-33.24-32.3-14.84-.77-27.43,4-35.78,16.76-3.17,4.86-3.52,3.37-6.26-.38-3.65-5-8.18-10.16-13.53-12.92-15.84-8.15-35.89-2.18-44.08,10.05-.83,1.25-2.51,1.93-3.8,2.88-.14-1.41-.34-2.81-.41-4.22-.54-11-.53-11-11.77-10.93-.71,0-1.42,0-2.13,0-7.81.14-7.89.14-7.92,8.3C756.4,312,756.44,328.35,756.43,344.7Zm280.46,13.39h0c0-11.73.16-23.46,0-35.18-.27-15.88-8-27-22.65-32.84a59.07,59.07,0,0,0-45.64.18c-7.78,3.15-14.29,8.19-18.25,15.63-2.1,3.95-2.8,8.64-4.13,13,4,.61,8,1.67,12,1.69,3.55,0,7.35,1.51,10.34-3,7.93-12,17.45-15.35,31-12a19.85,19.85,0,0,1,14.67,24.68c-.38,1.38-2.75,3-4.33,3.15-7.77.82-15.64.82-23.38,1.82-8.4,1.08-17,2-25,4.66-14.35,4.74-21,14.64-21,28.62,0,14.31,7.33,25.25,20.58,30.56,13,5.2,36.1,5.39,49.78-11.09,1-1.2,2.61-1.88,3.94-2.81.19,1.3.49,2.59.56,3.9.58,12.27.57,12.27,12.42,12.2a22.77,22.77,0,0,1,3.2,0c4.5.6,6.22-1,6.1-5.83C1036.69,383,1036.89,370.53,1036.89,358.09Zm77.59-72.24c-14.84-.06-27.93,4.41-38.31,15.36-10.85,11.46-14.69,25.69-15.19,40.94-1.15,34.88,18.42,58.29,50.65,60,18.76,1,35.38-4.26,45.77-21.26,3-4.92,3.79-11.19,5.59-16.85-5.14-.42-10.29-.85-15.44-1.26-3.39-.27-5.63.28-7,4.34-4.22,12.22-14.35,16.12-26.12,16-12.09-.08-21-6.08-25.93-17.17-5.68-12.88-5.87-26.25-1.51-39.5,3.94-12,11.71-20.31,25.06-21.27s23.77,3.76,28.63,17.05c1.23,3.38,3,4.3,6.22,4,2.47-.2,5,0,7.45,0,9.92-.09,10.22-.54,6.86-10.29C1154.68,297.19,1137.17,285.88,1114.48,285.85Z" transform="translate(-419.93 -0.02)"/><path class="cls-1" d="M916.71,642.71c-.77,39.29-5.15,68.16-20.55,94.45-23.7,40.48-64.5,54.89-106.25,49.45-43.19-5.63-71.13-30.94-84.76-71.17-15.71-46.38-15.16-93.1,5.09-138.26,19.2-42.84,58.55-63,104.7-59.59,49.52,3.67,80.82,35,93.46,78.95C913.55,614.46,915.1,633.42,916.71,642.71Z" transform="translate(-419.93 -0.02)"/><path class="cls-2" d="M1002.44,349.89c13.21-.32,13.78.35,11.2,13.54-3.52,18-31.33,27.63-45.27,15.61-8.46-7.29-6-20,4.87-24.82a18.44,18.44,0,0,1,5-1.71C986.29,351.53,994.37,350.75,1002.44,349.89Z" transform="translate(-419.93 -0.02)"/></svg>';


export default function LaptopApp(props) {
  const user = useSelector((state) => state).authReducer.user;
  const [keys, setKeys] = useState([]);
  const [licenseCount, setLicenseCount] = useState(1);

  const content = useSelector((state) => state).contentReducer;

  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    // get device keys
    getKeys();
  }, []);

  const getKeys = () => {
    getOnlineNode(`api/devicekey?_format=json`)
      .then((response) => {
        const serverKeys = response.data.keys;
        const serverCount = response.data.license ? response.data.license : 1;

        if (serverCount) {
          setLicenseCount(Number(serverCount));
        }

        const _keys = [];

        for (let i = 0; i < serverCount; i++) {
          const keySet = serverKeys[i];
          let data = {
            key: "",
            name: "",
          };

          if (keySet) {
            data = {
              key: keySet.key ? keySet.key : "",
              name: keySet.name ? keySet.name : "",
            };
          }

          _keys.push(data);
        }

        setKeys(_keys);
        setLoading(false);
        setError(false);
      })
      .catch((error) => {
        // error
        setErrorMessage(
          "Failed to get keys from the server. Please try again later."
        );
        setLoading(false);
        setError(true);
      });
  };

  const saveKeys = () => {
    patchNode(`/api/devicekey`, keys, user.csrf_token)
      .then((response) => {
        setLoading(true);
        setError(false);
        getKeys();
        setSuccess(true);
      })
      .catch((error) => {
        setErrorMessage("Failed to save keys. Please try again later.");
        setLoading(false);
        setError(true);
        setSuccess(false);
      });
  };

  if (isLoading) {
    return (
      <div className="circular-container fs">
        <CompanyappLoader />
      </div>
    );
  } else {
    return (
      <>
        <div className="laptop-app screen d-flex flex-column justify-content-between h-100 mx-lg-auto">
          <Row className="gx-0">
            <Col>
              <Row className="mb-3">
                <style dangerouslySetInnerHTML={{ __html: content.css ? content.css : '' }} />
                <div className='dynamic-content app' dangerouslySetInnerHTML={{ __html: content.app ? content.app : '' }} />
              </Row>
    
              {/* <Row className="mt-5 mx-5 px-3">
                {content.windows && (
                  <Col>
                    <Row>
                      <Col className="d-flex justify-content-center align-items-center">
                        <div
                          className="os-logo mb-4"
                          dangerouslySetInnerHTML={{ __html: winLogo }}
                        ></div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="d-flex justify-content-center align-items-center">
                        <Button
                          className="download-add-in-btn mt-3"
                          owner="admin"
                          color="adminPrimary"
                          variant="contained"
                          startIcon={<FileDownloadOutlined />}
                          onClick={() => {
                            window.open(content.windows, '_blank');
                          }}
                        >
                          <Typography owner="admin" variant="button">
                            Download
                          </Typography>
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                )}

                {content.macos && (
                  <Col>
                    <Row>
                      <Col className="d-flex justify-content-center align-items-center">
                        <div
                          className="os-logo mb-4"
                          dangerouslySetInnerHTML={{ __html: macLogo }}
                        ></div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="d-flex justify-content-center align-items-center">
                        <Button
                          className="download-add-in-btn mt-3"
                          owner="admin"
                          color="adminPrimary"
                          variant="contained"
                          startIcon={<FileDownloadOutlined />}
                          onClick={() => {
                            window.open(content.macos, '_blank');
                          }}
                        >
                          <Typography owner="admin" variant="button">
                            Download
                          </Typography>
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
              <Row className="mt-5 pt-3">
                <Col>
                  <Typography owner="admin" variant="h5" color="adminText.dark">
                    Device Key
                  </Typography>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Typography owner="admin" variant="body2" lh="medium">
                    Please enter the Device Key for your Laptop App in the
                    relevant box below.
                  </Typography>
                </Col>
              </Row> */}

              {keys.length > 0 && (
                <>
                  {keys.map((set, index) => {
                    return (
                      <Row key={`key-${index}`}>
                        <Col xs={4}>
                          <Row className="mt-2">
                            <Col>
                              <Typography
                                owner="admin"
                                variant="form-group-label"
                                lh="wide"
                              >
                                Device Key
                              </Typography>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextField
                                id={`key-${index}`}
                                defaultValue={set.key}
                                placeholder="XXXXXX"
                                maxLength={6}
                                size="small"
                                inputProps={{
                                  maxLength: 6,
                                  style: { textTransform: "uppercase" },
                                }}
                                onChange={(event) => {
                                  let data = keys;
                                  data[index].key = event.target.value;
                                  setKeys(data);
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={8}>
                          <Row className="mt-2">
                            <Col>
                              <Typography
                                owner="admin"
                                variant="form-group-label"
                                lh="wide"
                              >
                                Name of device (optional)
                              </Typography>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextField
                                id={`name-${index}`}
                                defaultValue={set.name}
                                placeholder="Device name"
                                size="small"
                                onChange={(event) => {
                                  let data = keys;
                                  data[index].name = event.target.value;
                                  setKeys(data);
                                }}
                                fullWidth
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                  <Row className="mt-3 justify-content-end">
                    <Col xs="auto">
                      <Button
                        className="submit-btn"
                        onClick={() => {
                          saveKeys();
                        }}
                        sx={{
                          textTransform: "none",
                          backgroundColor: "secondary.main",
                          color: "solid.light",
                          "&:hover": {
                            backgroundColor: "secondary.dark",
                          },
                        }}
                      >
                        <Typography
                          owner="admin"
                          variant="subtitle1"
                          weight="medium"
                          lh="wide"
                        >
                          Save keys
                        </Typography>
                      </Button>
                    </Col>
                  </Row>
                </>
              )}

              {/* <Row className="mt-5">
                <Col>
                  <Typography owner="admin" variant="body2" lh="medium">
                    PLEASE NOTE: A standard subsciription allows one device per
                    user. To request additional Device Keys for other laptops,
                    please contact{" "}
                    <a href="mailto:support@companyapp.co.uk">
                      support@companyapp.co.uk
                    </a>
                    . Additional fees apply.
                  </Typography>
                </Col>
              </Row> */}
            </Col>
          </Row>
          <Creator />
        </div>

        <Snackbar
          open={isError}
          autoHideDuration={5000}
          onClose={() => {
            setError(false);
          }}
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => {
                setError(false);
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          }
        >
          <Alert
            onClose={() => {
              setError(false);
            }}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {errorMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={isSuccess}
          autoHideDuration={5000}
          onClose={() => {
            setSuccess(false);
          }}
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => {
                setSuccess(false);
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          }
        >
          <Alert
            onClose={() => {
              setSuccess(false);
            }}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            Your keys have been updated successfully.
          </Alert>
        </Snackbar>
      </>
    );
  }
}
